import React, { useEffect, useRef, useState } from 'react';
import LabelEventGraph from '../LabelEventGraph';
import * as glossaire_type_de_graphe from '../../../../../ressources/glossaires/glossaire_type_de_graphe';
import { fetchGraphData } from './labelEventGraphApi';

const GRAPH_ID = 1;
const HEADER_HEIGHT = 20;
const PADDING = 8;

const LabelEventGraphGeoDemo = () => {
  const containerRef = useRef(null);

  const [dims, setDims] = useState({ width: undefined, height: undefined });
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  const [signalData, setSignalData] = useState([]);
  const [configuration, setConfiguration] = useState({});
  const [donneesGraphe, setDonneesGraphe] = useState(null);

  // ── Chargement initial ────────────────────────────────────────────────────────

  useEffect(() => {
    fetchGraphData(GRAPH_ID)
      .then((res) => {
        if (!res.ok) {
          setFetchError(res.error);
          setLoading(false);
          return;
        }
        const { config, data, graphCurves, id_sensor } = res.data;

        setSignalData(data);
        setConfiguration({
          title: config.title || '',
          subtitle: config.subtitle || '',
          xaxis: config.xaxis || {},
          yaxis: config.yaxis || {},
          yaxis2: config.yaxis2 || {},
        });
        setDonneesGraphe({
          config: {
            graph_id: GRAPH_ID,
            graph_type_id: glossaire_type_de_graphe.graphe_x_t_label,
            title: config.title || '',
            sensor_name: config.sensor_name || '',
            prefix: config.prefix || '',
          },
          graphCurves: graphCurves || [],
          id_sensor: id_sensor || [],
          data,
        });
        setLoading(false);
      })
      .catch(() => {
        setFetchError('Impossible de charger les données du graphe');
        setLoading(false);
      });
  }, []);

  // ── Redimensionnement ─────────────────────────────────────────────────────────

  useEffect(() => {
    const update = () => {
      if (containerRef.current) {
        setDims({
          width: containerRef.current.offsetWidth - 28,
          height: window.innerHeight - HEADER_HEIGHT - PADDING,
        });
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  // ── Rendu ─────────────────────────────────────────────────────────────────────

  if (loading)
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        Chargement…
      </div>
    );

  if (fetchError)
    return (
      <div style={{ color: 'red', padding: 24, fontFamily: 'Montserrat, sans-serif' }}>
        Erreur : {fetchError}
      </div>
    );

  return (
    <div ref={containerRef} style={{ height: '100vh', overflow: 'hidden' }}>
      <LabelEventGraph
        donnees={signalData}
        configuration={configuration}
        donneesGraphe={donneesGraphe}
        dimensionWidth={dims.width}
        dimensionHeight={dims.height}
        switchAfficherModifierIntervalle={() => {}}
        viewobj_json_content={{ displayModeBar: true }}
      />
    </div>
  );
};

export default LabelEventGraphGeoDemo;
